import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import ConciergeAI from "./ConciergeAI";
import BookConsultingButton from "./BookConsultingButton";
import FloatingVideo from "./FloatingVideo";
import Popups from "./Popups";
import BackToTop from "./BackToTop";
import CommandPalette from "./CommandPalette";
import SmoothScroll from "./SmoothScroll";
import ScrollToTop from "./ScrollToTop";
import ChatBubble from "./ChatBubble";

export default function Layout() {
  const [cmdOpen, setCmdOpen] = useState(false);

  return (
    <>
      <SmoothScroll />
      <ScrollToTop />
      <Header onOpenCommand={() => setCmdOpen(true)} />
      <main className="min-h-screen">
        <Outlet />
      </main>
      <Footer />
      <ConciergeAI />
      <BookConsultingButton />
      <FloatingVideo />
      <Popups />
      <BackToTop />
      <ChatBubble />
      <CommandPalette open={cmdOpen} onOpenChange={setCmdOpen} />
    </>
  );
}
